module.exports = __webpack_public_path__ + "img/gz3.541f3d1c.jpg";